module.exports = __webpack_public_path__ + "static/media/file-upload.3983b1f0.svg";